import React from 'react';
import { Helmet } from 'react-helmet';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleButton from 'components/RoleButton';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
// @ts-ignore
import GroupDeleteModal from 'components/GroupDeleteModal';

// Child Components
// @ts-ignore
import GroupsTable from './components/GroupsTable';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Groups = (): React.ReactElement => (
    <ErrorBoundary
        namespace="Groups"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>
                {'Groups - '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <PageTitleAndFilters
            title="Groups"
            searchInputPlaceholder="Search groups"
            Button={
                <RoleButton
                    requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                    params={{
                        groupModal: true,
                        selectedGroup: undefined
                    }}
                >
                    Create Group
                </RoleButton>
            }
            currentEntity
            currentSeason
            hideFilters
        />
        <PageWrapper top={0} bottom={50}>
            <GroupsTable />
        </PageWrapper>
        <CurrentSeasonInProgressGate>
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <GroupDeleteModal />
            </RoleGate>
        </CurrentSeasonInProgressGate>
    </ErrorBoundary>
);

export default Groups;
